import React, { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { geocodeByAddress, getLatLng, } from 'react-places-autocomplete';
import { Modal } from "react-bootstrap";
import { DE } from "../Languages/DE";
import { EN } from "../Languages/EN";
import LanguageContext from "../helper/LanguageContext";
import ShareMarker from "./ShareMarker";
import { $crud } from "../helper/CrudFactory";
import Geocode from "react-geocode";
import "./ShareMapDialog.css";
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_KEY);
Geocode.setLocationType("ROOFTOP");


const ShareMapDialog = ({ company, show, handleClose, isInternal }) => {
    const { isGerm, strings } = React.useContext(LanguageContext)
    const [showingInfoWindow, setShowingInfoWindow] = useState(false)
    const [activeMarker, setActiveMarker] = useState({})
    const [selectedPlace, setSelectedPlace] = useState({})
    const [markers, setMarkers] = useState([])
    const [address, setAddress] = useState('')
    const [mapCenter, setMapCenter] = useState({})

    // Determine if Kjuup+ based on prop or company.isKjuup property
    const isInternalCompany = isInternal !== undefined ? isInternal : (company && company.isKjuup);

    const onMarkerClick = (marker) => {
        console.log(marker)
    }
    const onMapClicked = (props) => {
        if (showingInfoWindow) {
            setShowingInfoWindow(false)
            setActiveMarker(null)
        }
    };
    const handleShowMarker = async () => {
        if (showingInfoWindow) {
            setShowingInfoWindow(false)
            setActiveMarker({})
        }
    }

    const handleChange = address => {
        setAddress(address)
    };


    const handleSelect = address => {
        setAddress(address)
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                console.log('Success', latLng);
                setMapCenter(latLng)
            })
            .catch(error => console.error('Error', error));
    };

    useEffect(() => {
        if (company) {
            let add = `${company.houseNo ? company.houseNo + "," : ""} ${company.street}, ${company.city}, ${company.postCode ? company.postCode + "," : ""} ${company.country ? company.country : ''}`
            if (company.full_address) {
                Geocode.fromAddress(company.full_address).then(
                    (results) => {
                        const { lat, lng } = results.results[0].geometry.location;
                        let ll = {
                            lat: lat,
                            lng: lng
                        }
                        setMapCenter(ll)
                    })
            }
            else {
                Geocode.fromAddress(add).then(
                    (results) => {
                        const { lat, lng } = results.results[0].geometry.location;
                        let ll = {
                            lat: lat,
                            lng: lng
                        }
                        setMapCenter(ll)
                    })
            }
        }
    }, [company])


    const copyLocationLink = async () => {
        let cmp = company;
        const locationUrl = encodeURI(`https://maps.google.com/?q=${cmp.name ? cmp.name + ' ' : ''}${cmp.street ? cmp.street + ' ' : ''}${cmp.city ? cmp.city + ' ' : ''}${cmp.country ? cmp.country : ''}`)
        navigator.clipboard.writeText(locationUrl).then(() => {
            $crud.notify({
                type: 'success',
                message: isGerm ? 'Link kopiert!' : 'Link copied!'
            })
        })
    }

    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            animation={false}
            className={`share-location-modal ${isInternalCompany ? 'share-location-internal' : ''}`}
            centered
            dialogClassName="share-location-dialog"
        >
            {/* Custom Header */}
            <div className="share-location-header">
                <div className="share-location-header-content">
                    <span className="material-symbols-outlined share-location-header-icon">
                        location_on
                    </span>
                    <span className="share-location-title">
                        {strings.send_location}
                    </span>
                </div>
                <button 
                    className="kj-btn kj-btn--icon kj-btn--neutral kj-btn--round"
                    onClick={handleClose}
                    type="button"
                    aria-label="Close"
                >
                    <span className="material-symbols-outlined">
                        close
                    </span>
                </button>
            </div>

            {/* Map Body */}
            <Modal.Body className="share-map-dialog__body">
                <div style={{ height: '300px', width: '100%', borderRadius: '0' }}>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
                        defaultCenter={mapCenter}
                        defaultZoom={11}
                        center={{
                            lat: mapCenter.lat,
                            lng: mapCenter.lng
                        }}
                    >
                        <ShareMarker hideMarker={handleShowMarker}
                            lat={mapCenter.lat} lng={mapCenter.lng}
                            marker={company}
                            name={company.name} />

                    </GoogleMapReact>
                </div>
            </Modal.Body>

            {/* Footer */}
            <div className="share-location-footer">
                <div className="share-location-footer-content">
                    <div className="share-location-info">
                        <div className="share-location-text">
                            <span className="share-location-label">
                                {strings.send_location}
                            </span>
                            <span className="share-location-accuracy">
                                {strings.up_to_50m_exact}
                            </span>
                        </div>
                    </div>
                    <button 
                        className="kj-btn kj-btn--icon kj-btn--lg kj-btn--neutral kj-btn--round"
                        onClick={copyLocationLink}
                        type="button"
                        title={isGerm ? "Link kopieren" : "Copy link"}
                    >
                        <span className="material-symbols-outlined">
                            content_copy
                        </span>
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ShareMapDialog;
